<div class="component-viewer">

  <ng-container *ngIf="!isGlobalOutingSet()">
    <mat-card>
      <mat-card-content>
        <p class="mat-body-1">Select an outing and iteration from the dashboard to manage teams.</p>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <ng-container *ngIf="isGlobalOutingSet() && selectedIteration">
    <header class="page-header">
      <h1 class="mat-h1">Teams</h1>
      <p class="mat-body-2 meta-line">
        <mat-icon aria-hidden="true">schedule</mat-icon>
        <span>Outing start: <strong>{{ selectedIteration.startDate | date: 'EEE, MMM d, y' }}</strong> at
          <strong>{{ selectedIteration.startDate | date: 'shortTime' }}</strong></span>
      </p>
      <p class="mat-body-2 count-line" *ngIf="!isLoading">{{ teams.length }} team(s), {{ allRegistrations.length }} registration(s)</p>
    </header>
    
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

    <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="start">
      <mat-tab label="Teams">
        <section class="teams-grid" *ngIf="teams.length > 0" aria-label="Teams">
          <mat-card *ngFor="let team of teams" class="team-card">
            <mat-card-header>
              <mat-card-title>{{ team.captain }}</mat-card-title>
              <mat-card-subtitle>
                <span class="meta-block">
                  <mat-icon aria-hidden="true">flag</mat-icon>
                  Starting hole: {{ team.startingHoleSummary }}
                </span>
                <span class="meta-block" *ngIf="selectedIteration?.startDate">
                  <mat-icon aria-hidden="true">event</mat-icon>
                  Start time: {{ selectedIteration.startDate | date: 'shortTime' }}
                </span>
              </mat-card-subtitle>
            </mat-card-header>
            <mat-divider />
            <mat-card-content>
              <p class="section-label mat-subtitle-2">Players ({{ team.members.length }})</p>
              <mat-chip-set aria-label="Team members">
                <mat-chip *ngFor="let m of team.members">{{ m.firstName }} {{ m.lastName }}</mat-chip>
              </mat-chip-set>
            </mat-card-content>
            <mat-card-actions align="end">
              <button mat-stroked-button color="primary" type="button" (click)="editTeam(team)">
                <mat-icon>edit</mat-icon>
                Edit team
              </button>
            </mat-card-actions>
          </mat-card>
        </section>
      </mat-tab>
      <mat-tab label="Unassigned Players">
        <mat-card *ngIf="!isLoading && teams.length === 0 && unassignedPlayers.length === 0" class="empty-state">
          <mat-card-content>
            <p class="mat-body-1">No registrations found for this iteration.</p>
          </mat-card-content>
        </mat-card>
    
        <section *ngIf="unassignedPlayers.length > 0" class="unassigned-section" aria-label="Players without a team">
          <h2 class="mat-h2 section-title">Players without a team captain</h2>
          <p class="mat-body-2 section-hint">
            Assign each player to an existing team or create a new team with that player as captain.
          </p>
          <mat-card>
            <mat-card-content class="unassigned-table-wrap">
              <table class="unassigned-table">
                <thead>
                  <tr>
                    <th scope="col">Player</th>
                    <th scope="col">Assign to</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let p of unassignedPlayers">
                    <td>{{ p.firstName }} {{ p.lastName }}</td>
                    <td>
                      <mat-form-field appearance="outline" class="assign-field" subscriptSizing="dynamic">
                        <mat-label>Team</mat-label>
                        <mat-select [(ngModel)]="assignChoice[p.id]" [attr.aria-label]="'Assign ' + p.firstName + ' ' + p.lastName">
                          <mat-option *ngFor="let team of teams; let ti = index" [value]="'existing:' + ti">
                            {{ team.captain }} — Hole: {{ team.startingHoleSummary }}
                          </mat-option>
                          <mat-option [value]="newTeamOptionValue(p)">
                            New team — {{ p.firstName }} {{ p.lastName }} as captain
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </td>
                    <td>
                      <button mat-flat-button color="primary" type="button" (click)="applyAssign(p)" [disabled]="isLoading">
                        Assign
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </mat-card-content>
          </mat-card>
        </section>
      </mat-tab>
    </mat-tab-group>

  </ng-container>
</div>
